import React, { PropTypes } from 'react';
import { TextField } from 'material-ui';
import TwoColumnRow from '../../../../tc-ui/two-column-row';

const BankInfo = (props) => {
  const bankTextFields = [
    {
      hint: 'Financial institution',
      shortName: 'financialInstitution',
      error: props.financialInstitutionError,
      onChange: ({ target: { value } }) =>
        props.onChange({ key: 'financialInstitution', value: value.trim() }),
    },
    {
      hint: 'Branch',
      shortName: 'branch',
      error: props.branchError,
      onChange: ({ target: { value } }) =>
        props.onChange({ key: 'branch', value: value.trim() }),
    },
    {
      hint: 'Account name',
      shortName: 'accountName',
      error: props.accountNameError,
      onChange: ({ target: { value } }) =>
        props.onChange({ key: 'accountName', value: value.trim() }),
    },
    {
      hint: 'Account number',
      shortName: 'accountNumber',
      error: props.accountNumberError,
      onChange: ({ target: { value } }) =>
        props.onChange({ key: 'accountNumber', value: value.trim() }),
    },
    {
      hint: 'BSB / Routing number',
      shortName: 'bsbRoutingNumber',
      error: props.bsbRoutingNumberError,
      onChange: ({ target: { value } }) =>
        props.onChange({ key: 'bsbRoutingNumber', value: value.trim() }),
    },
    {
      hint: 'Iban / Swift code',
      shortName: 'ibanSwiftCode',
      error: props.ibanSwiftCodeError,
      onChange: ({ target: { value } }) =>
        props.onChange({ key: 'ibanSwiftCode', value: value.trim() }),
    },
  ];

  return (
    <div>
      <p style={{ fontWeight: '600', color: '#757575', marginBottom: '0px' }}>Bank Information</p>
      {bankTextFields.map((bankTextField, index) => {
        return (
          <TwoColumnRow
            key={index}
            outerContainerStyle={{ display: 'flex', alignItems: 'baseline', marginBottom: '4px' }}
            leftColumnContent={bankTextField.hint}
            leftColumnStyle={{ width: '35%', color: 'rbga(0, 0, 0, 0.77)' }}
            rightColumnContent={<TextField
              inputStyle={{ fontSize: '14px' }}
              hintStyle={{ fontSize: '14px' }}
              hintText= {bankTextField.hint}
              errorText={bankTextField.error}
              onChange={bankTextField.onChange}
              defaultValue={props[bankTextField.shortName]}
            />}
          />
        );
      })}
    </div>
  );
};

BankInfo.propTypes = {
  title: PropTypes.string,
  currency: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  financialInstitutionError: PropTypes.string,
  branchError: PropTypes.string,
  accountNameError: PropTypes.string,
  accountNumberError: PropTypes.string,
  bsbRoutingNumberError: PropTypes.string,
  ibanSwiftCodeError: PropTypes.string,
  currencyError: PropTypes.string,
};

export default BankInfo;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/billing/bank-info.jsx